// extracted by mini-css-extract-plugin
module.exports = {"subscription":"Datablock_Subscription_subscription__ctNZJ"};